export default __webpack_public_path__ + "locales/vi/InviteDialog.json?hash=2ef92cdcf71cdf53a15df0994e125191";